/* ============================================================================
   SWITZERLAND 1291 — V2 restyle motion. Vanilla, sec (120-180ms).
   Respecte prefers-reduced-motion. Re-init sur shopify:section:load (editeur).
   ============================================================================ */
(function () {
  "use strict";
  var motionOK = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initReveals(root) {
    var scope = root || document;
    var reveals = scope.querySelectorAll(".sg-reveal, .sg-stagger");
    if (!reveals.length) return;
    if (motionOK && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add("sg-in"); io.unobserve(en.target); }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add("sg-in"); });
    }
  }

  function initRules(root) {
    var scope = root || document;
    var rules = scope.querySelectorAll(".sg-rule");
    if (!rules.length) return;
    if (motionOK && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add("sg-on"); io.unobserve(en.target); }
        });
      }, { threshold: 0 });
      rules.forEach(function (r) { r.classList.add("sg-pending"); io.observe(r); });
    }
  }

  function initHero(root) {
    var scope = root || document;
    var hero = scope.querySelector(".sg1291-hero");
    if (hero && motionOK && !hero.dataset.sgAnimated) {
      hero.dataset.sgAnimated = "1";
      hero.classList.add("sg-prep");
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          hero.classList.add("sg-go");
          setTimeout(function () { hero.classList.remove("sg-prep"); }, 560);
        });
      });
    }
    // compteur 1291 -> 2026
    var counter = scope.querySelector("[data-sg-counter]");
    if (counter && motionOK && !counter.dataset.sgCounted) {
      counter.dataset.sgCounted = "1";
      var FROM = parseInt(counter.getAttribute("data-from"), 10) || 1291;
      var TO = parseInt(counter.getAttribute("data-to"), 10) || 2026;
      var DUR = 1200, t0 = null;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / DUR, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        counter.textContent = Math.round(FROM + (TO - FROM) * eased);
        if (p < 1) requestAnimationFrame(step);
      }
      counter.textContent = FROM;
      requestAnimationFrame(step);
    }
  }

  function initAll(root) {
    initReveals(root);
    initRules(root);
    initHero(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Editeur de thème : ré-initialise la section rechargée
  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });
})();
